import React from 'react';

// mui
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

export interface CountsProps {
    count: any;
    index: number;
}

const Counts: React.FC<CountsProps> = ({ count, index }) => {
    return (
        <Grid item xs={4} key={`counts-${index}`}>
            <Paper
                elevation={4}
                sx={{
                    p: 3,
                    backgroundImage: count.color,
                }}
            >
                <Grid container alignItems={'center'}>
                    <Grid item xs={2}>
                        {count.icon}
                    </Grid>
                    <Grid item>
                        <Typography
                            variant={'body2'}
                            sx={{
                                fontWeight: 'bold',
                                color: '#fff',
                            }}
                        >
                            {count.title}
                        </Typography>
                        <Typography
                            variant={'h5'}
                            sx={{
                                fontWeight: 'bold',
                                color: '#fff',
                            }}
                        >
                            {count.data}
                        </Typography>
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    );
};

export default Counts;
